import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import Chart from "react-apexcharts";
import { usagePrediction } from "../../helpers/api";

// const data = {
//     ,


//     ,
// };


function MyApexChart() {
    const [prediction, setPrediction] = useState({ key: "" })


    const [one, setOne] = useState({
        series: [
            {
                name: "Sales",
                // data: [4, 2, 1, 2, 24, 23, 12, 34],
                data: [0, 0, 0, 0, 0, 0, 0, 182, 182, 238, 238, 280, 280, 294, 306, 318, 329, 341, 353, 365],
            },
        ]
    })

    const [dates, setDates] = useState([])

    const [two, setTwo] = useState({
        options: {
            chart: {
                height: 350,
                type: "line",
            },
            forecastDataPoints: {
                count: parseInt(prediction?.key) || 6,
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                width: 5,
                curve: "smooth",
                colors: ["#51218d"],
            },
            xaxis: {
                categories: dates,
            },
            fill: {
                type: "gradient",
                gradient: {
                    shade: "light",
                    gradientToColors: ["#8F43EE", "#E7D4FF"],
                    shadeIntensity: 5,
                    type: "horizontal",
                    opacityFrom: 0,
                    opacityTo: 1,
                    stops: [0, 60, 100, 100],
                    colorStops: [
                        [
                            {
                                offset: 60,
                                color: '#8F43EE',
                                opacity: 1
                            },
                            {
                                offset: 50,
                                color: '#E7D4FF',
                                opacity: 50
                            },

                        ]
                    ]
                },
            },
        }
    })

    const getUsage = async () => {
        try {
            const response = await usagePrediction();

            console.log("RRREEEEDDDDD", response?.predictionKey);

            setPrediction({ ...prediction, key: response?.predictionKey })

            const newdata = response.message.map((item) => Number(item?.total.toFixed(0, 2)));
            const newdate = response.message.map((item) => `jul ${item?.day}`);

            console.log(newdata);
            console.log(newdate);
            // Update the 'data' property of 'one.series[0]'

            setOne((prevState) => ({
                ...prevState,
                series: [{ ...prevState.series[0], data: newdata }],
            }));
            setDates(newdate)

        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        getUsage();
    }, [])

    return (
        <div>
            <Chart
                options={two.options}
                series={one.series}
                type="area"
                height={350}
            />
        </div>
    );
}


export default MyApexChart;